import {PlanbordResource} from '@/types/api-object-extensions';
import Dates from '@cquential/date-utils';
import {OrganisationDeploymentState} from '@cquential/api';

export default class WorkingResourceMapCreator {
    private result: Record<string, Record<number, PlanbordResource[]>> = {};
    private hasRun: boolean = false;
    private readonly resources: PlanbordResource[];
    private readonly precision: number;
    private readonly organisationDeploymentStates: Record<number, OrganisationDeploymentState>;
    private readonly deploymentTypesToUse: Record<number, true>;

    constructor(resources: PlanbordResource[], precision: number, organisationDeploymentStates: Record<number, OrganisationDeploymentState>, deploymentTypesToUse: Record<number, true>) {
        this.resources = resources;
        this.precision = precision;
        this.organisationDeploymentStates = organisationDeploymentStates;
        this.deploymentTypesToUse = deploymentTypesToUse;
    }

    private run(): void {
        for (const resource of this.resources) {
            for (const deployment of Object.values(resource.deployments).flat()) {
                for (const specification of deployment.specifications!) {
                    if (!this.organisationDeploymentStates[specification.stateId].properties.fulfillsRequiredShift || !(specification.typeId in this.deploymentTypesToUse)) {
                        continue;
                    }

                    const date: Date = new Date(Math.round(specification.begin.getTime() / this.precision) * this.precision);
                    const endDate: Date = new Date(Math.round(specification.end.getTime() / this.precision) * this.precision);
                    while (date < endDate) {
                        const day: string = Dates.Formatter.formatDateComputerFriendly(date);
                        this.result[day] ??= {};
                        this.result[day][date.getTime()] ??= [];
                        this.result[day][date.getTime()].push(resource);

                        date.setTime(date.getTime() + this.precision);
                    }
                }
            }
        }
    }

    public getResult(): Record<string, Record<number, PlanbordResource[]>> {
        if (!this.hasRun) {
            this.run();
            this.hasRun = true;
        }

        return this.result;
    }
}
